import { useCallback, useMemo } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'urql'
import { Customer } from '../../../gql/graphql'
import { compact } from '../../_helpers/compact'
import { LOGIN_PATH } from '../../_lib/festival'
import { publicFestivalsQuery } from '../../_lib/graphql/queries'
import { Dialog } from '../../_ui/Dialog'
import { FestivalCard } from '../FestivalCard'
import { PublicLayout } from '../PublicLayout'
import { useServiceWorker } from '../ServiceWorker'
import { SwUpdateDialog } from '../SwUpdateDialog'
import { LoginForm } from './LoginForm'

export const Login = () => {
  const { isUpdateAvailable, updateAssets } = useServiceWorker() || {}
  const location = useLocation()
  const navigate = useNavigate()
  const loginOpen = location.pathname === LOGIN_PATH
  const closeLogin = useCallback(() => navigate('/', { replace: true }), [navigate])
  const [{ data }] = useQuery({ query: publicFestivalsQuery })

  const festivals = useMemo(() => compact(data?.publicFestivals) as Customer[], [data?.publicFestivals])

  return (
    <PublicLayout>
      <div className={'mt-8 max-w-3xl lg:mt-16'}>
        <h1 className={'text-4xl font-bold tracking-tight text-primary-200 text-balance sm:text-5xl lg:text-6xl'}>
          Ein Konto. Alle Festivals.
        </h1>
        <p className={'mt-5 max-w-xl text-lg leading-8 text-gray-600'}>
          Entdecke Festivals, tritt der Crew bei und verwalte Schichten, Check-ins und mehr an einem Ort.
        </p>
        <div className={'mt-8 flex flex-wrap gap-3'}>
          <Link
            to={LOGIN_PATH}
            className={'inline-flex items-center rounded-full bg-primary-200 px-7 py-3 text-sm font-semibold text-white hover:bg-primary-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
          >
            Anmelden
          </Link>
          {festivals.length > 0 && (
            <a
              href={'#festivals'}
              className={'inline-flex items-center rounded-full border border-primary-200 px-7 py-3 text-sm font-semibold text-primary-200 hover:bg-primary-200 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
            >
              Festivals entdecken
            </a>
          )}
        </div>
      </div>

      {festivals.length > 0 && (
        <section
          id={'festivals'}
          className={'mt-20 scroll-mt-6'}
        >
          <h2 className={'text-3xl font-bold tracking-tight text-primary-200'}>
            Festivals entdecken
          </h2>
          <p className={'mt-2 mb-8 text-base text-gray-600'}>
            Schau dir an, wo du mitmachen kannst. Nach der Anmeldung trittst du mit einem Klick bei.
          </p>
          <div className={'grid gap-6 sm:grid-cols-2 lg:grid-cols-3'}>
            {festivals.map(festival => (
              <FestivalCard
                key={festival.id}
                festival={festival}
                actions={(
                  <Link
                    to={`/festivals/${festival.slug}`}
                    className={'inline-flex items-center justify-center rounded-full bg-primary-200 px-6 py-2.5 text-sm font-semibold text-white hover:bg-primary-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
                  >
                    Details ansehen
                  </Link>
                )}
              />
            ))}
          </div>
        </section>
      )}

      <Dialog
        title={'Anmelden'}
        open={loginOpen}
        onClose={closeLogin}
        className={'sm:max-w-md'}
      >
        <LoginForm />
      </Dialog>

      {isUpdateAvailable && updateAssets && (
        <SwUpdateDialog />
      )}
    </PublicLayout>
  )
}
